const splitCardNumber = (number: string) => (number.replace(/[a-zA-Zа-яА-Я]/g, '').trim()).replace(/(\d{4}(?!\s))/g, '$1 ').trim();

export {
  splitCardNumber
};
